import { Form, InputNumber, Modal, notification } from "antd";
import { useState } from "react";
import { addPayout } from "../actions/acc_actions";

export default function AddPayoutModal({
  open,
  onClose,
  accountUrn,
  onSuccess,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();

      setLoading(true);

      await addPayout({
        accountUrn,
        amount: values.amount,
      });

      notification.success({
        message: "Payout Added Successfully",
        description: `Amount ${values.amount} has been added.`,
        placement: "topRight",
      });

      form.resetFields();
      onClose?.();
      onSuccess?.(); // optional callback
    } catch (err) {
      if (err?.errorFields) return;

      notification.error({
        message: "Failed to Add Payout",
        description:
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong.",
        placement: "topRight",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Add Payout"
      open={open}
      onCancel={() => {
        form.resetFields();
        onClose?.();
      }}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Payout Amount"
          name="amount"
          rules={[
            { required: true, message: "Please enter payout amount" },
            { type: "number", min: 1, message: "Minimum amount is 1" },
          ]}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            placeholder="Enter amount"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
